import { apiClient } from '../../api';
import { Path } from '../../api/backendUrl';
import { appConfig } from '../../config/appConfig';
import { logError } from '../../utils/logger';

const PRODUCT_PREFIX = appConfig.api.productServiceEndpoint;

export interface ProwlCategoryCount {
  categoryId: string;
  categoryName: string | null;
  providerCount: number;
}

export interface ProwlFacetCountParams {
  query?: string;
  categoryId?: string;
  city?: string;
  bookingType?: string;
}

export interface ProwlFacetCountResult {
  count: number | null;
  categoryName: string | null;
}

// GET /api/v1/service/public/prowl/category-counts — live provider counts
// per top-level category (pms#868). Powers the landing hero's starter chips.
// Server fails soft to `null`/`[]`; a null here means "say nothing" — callers
// must never fabricate a count.
export const getProwlCategoryCounts = async (
  city?: string
): Promise<ProwlCategoryCount[] | null> => {
  try {
    const res = await apiClient.get(
      `${PRODUCT_PREFIX}/${Path.prowlCategoryCounts}`,
      { params: city ? { city } : undefined }
    );
    return res.data?.data ?? null;
  } catch (error: any) {
    logError('Error fetching Prowl category counts:', error);
    return null;
  }
};

// GET /api/v1/service/public/prowl/facet-count — the honest count behind the
// hero's submit button ("5 bakers nearby" in the design, rendered here as
// "5 bakers in <city>" — city-scoped counts, never a distance claim, since
// `radius` is accepted on the wire but not geo-filtered server-side).
export const getProwlFacetCount = async (
  params: ProwlFacetCountParams
): Promise<ProwlFacetCountResult> => {
  try {
    const res = await apiClient.get(
      `${PRODUCT_PREFIX}/${Path.prowlFacetCount}`,
      { params }
    );
    return res.data?.data ?? { count: null, categoryName: null };
  } catch (error: any) {
    logError('Error fetching Prowl facet count:', error);
    return { count: null, categoryName: null };
  }
};
